import type { LanguageEnum } from './languageEnum';

/** Languages with email and quote-request templates, a fixed subset that doesn't grow with UI translations. */
export type CommunicationLanguageEnum = 'en' | 'de' | 'es' | 'fr' | 'it';

export const COMMUNICATION_LANGUAGES: CommunicationLanguageEnum[] = ['en', 'de', 'es', 'fr', 'it'];

/** Falls back to English, for features such as emails or Stripe checkout that only support these languages. */
export function toCommunicationLanguage(language: LanguageEnum | null | undefined): CommunicationLanguageEnum {
    return language != null && (COMMUNICATION_LANGUAGES as readonly string[]).includes(language)
        ? (language as CommunicationLanguageEnum)
        : 'en';
}
